import styled from '@emotion/styled';
import {Button, Typography} from '@mui/material';
import APP from 'src/styles/theme';

export const ButtonDiv = styled('div')`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
  margin-right: 17px;
  margin-top: 1rem;
`;
export const ApplyFilterButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  height: 35px;
  font-size: 6px;
  color: #ffffff;
  padding: 0 10px;
  border-radius: 5px;
  text-transform: capitalize;
  width: fit-content;
//   letter-spacing: 1px;
  background-color: ${APP.palette.primary.main};
  border: 1px solid ${APP.palette.primary.main};
  box-shadow: none;

  :hover {
    background-color: ${APP.palette.primary.main};
  }
`;

export const CloseFilterButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  height: 35px;
  font-size: 6px;
  padding: 0 12px;
  border-radius: 5px;
  text-transform: capitalize;
  width: fit-content;
//   letter-spacing: 1px;
  box-shadow: none;
  :hover {
    background-color: ${APP.palette.primary.main};
  }
`;

export const ApplyFilterTypography = styled(Typography)`
  padding-left: 2px;
  // letter-spacing: 2px;
  // color: #ffffff;
  font-size:14px;
`;
